import { useTranslation } from "react-i18next";
import FormSection from "../../../../common/components/functional/formSection/FormSection";
import { ContentKey } from "../../TalentDetails";
import { TalentContentKey } from "../../constants";
import TalentCertificatesTable from "../TalentCertificatesTable";
import TalentVehicleAvailable from "./TalentVehicleAvailable";

type Props = {
  handleOpenEditModal: (content: ContentKey) => void;
};

const TalentDrivingLicenses = ({ handleOpenEditModal }: Props) => {
  const { t } = useTranslation("talentProfile");

  const headers = [
    { text: t("talentProfile:drivingLicenseType") },
    { text: t("talentProfile:valid") },
  ];

  return (
    <FormSection title={t("talentProfile:drivingLicensesTitle")} margin>
      <TalentCertificatesTable
        handleOpenEditModal={handleOpenEditModal}
        drivingLicenseMode
        headers={headers}
        contentKey={TalentContentKey.DrivingLicenses}
        addButtonLabel={t("talentProfile:addDrivingLicense")}
      />
      <TalentVehicleAvailable />
    </FormSection>
  );
};

export default TalentDrivingLicenses;
